<template>
  <div class="mt-5 mx-0 editBG">
    <!-- <h1>User Management </h1> -->
    <!-- <v-snackbar v-model="snackbar" auto-height right top :timeout="timeout" vertical> User saved. </v-snackbar> -->

        <v-card class="editBG elevation-0">
          <!-- <v-card-title> <span class="pl-4 pt-3 pb-0 mb-0 headline">Edit Article</span> </v-card-title> -->

          <!-- <v-card-actions>
          </v-card-actions> -->

          <v-card-text mb-0>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-spacer></v-spacer>
                <v-btn icon @click="$router.go(-1)" mr-0 pr-0><v-icon>arrow_back</v-icon></v-btn>
                <!-- <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn> -->
                <v-btn color="black" flat @click="save">Save</v-btn>
                <v-flex xs12>
                  <v-text-field v-model="article.title" label="Title"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="article.subtitle" label="Subtitle"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.version" label="Version"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.support" label="Support"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.updates" label="Update"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.group" label="Group"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.at_work" label="At Work"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.publish_date" label="Publish Date"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="article.show_in_route" label="Routes Array"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <text-editor @input="article.body=$event" :value="article.body"></text-editor>
                  <v-divider class="my-4"></v-divider>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <!-- <v-btn class="justify-center layout px-0"> <v-icon small class="mr-2" @click="editItem(props.item)" > edit </v-icon> </v-btn> -->

  </div>
</template>

<script>
  import TextEditor from '@/components/artworks/TextEditor'
  import axios from '@/utils/apiClient'
  export default {
    data() {
      return {
        // article: null,
        editedIndex: -1,
        article: {
          title:'',
          version: '',
          subtitle: '',
          updates: '',
          help: '',
          at_work: '',
          support: '',
          show_in_route: '',
          group: ''
        },
        defaultItem: {
          title:'',
          version: '',
          subtitle: '',
          updates: '',
          help: '',
          at_work: '',
          support: '',
          show_in_route: '',
          group: ''
        }
        // new_article: { title: '', version: '' },
      }
    },
    props: ['editedItem'],
    beforeMount () {
      // console.log(this.editedItem)
      if (this.editedItem) {
        this.article = Object.assign({},this.editedItem)
      } 
      this.getArticle()
    },
    methods: {
      getArticle () {
        // console.log('getArtist')
        let url = `${this.$globals.apiserver}/support_articles/${this.$route.params.id}.json`
        // console.log(url)
        axios.get(url).then((response) => {
          // this.loading = false;
          // this.result = response.data[0]
          this.article = response.data
          // this.artist = response.data.artist
          // console.log(response.data)
          // console.log(response.data[0])
          // console.log(this.article)
          // console.log(this.artwork)
        }).catch((error) => { console.log(error) })
      },      
      createArticle () {
        // this.snackbar = true
        let url = `${this.$globals.apiserver}/support_articles.json`
        // console.log(url)
        axios.post(url, this.newItem).then((response) => {
          // this.result = response.data
          var o = Object.assign({ name: this.newItem.title})
          this.$store.dispatch('createArticle', o)
          this.save_user_form_display = false
          this.snackbar = false
          this.newItem = this.defaultItem
          // this.$router.push({path:`/users/edit/${this.result.id}`, params: {user: this.result}})
        }).catch((error) => { console.log(error) })
      },
      // close () {
        //   this.dialog = false
        //   setTimeout(() => {
        //     this.editedItem = Object.assign({}, this.defaultItem)
        //     this.editedIndex = -1
        //   }, 300)
      // },
      save () {
        let url = `${this.$globals.apiserver}/support_articles/${this.editedItem.id}.json`
        axios.put(url, { article: this.article}).then((response) => {
          // this.result = response.data
          // console.log(response.data)
          // this.$store.dispatch('updateArticle', this.result)
          // this.snackbar = true
        }).catch((error) => { console.log(error) })
        // if (this.editedIndex > -1) {
        //   Object.assign(this.$store.state.support_articles[this.editedIndex], this.editedItem)
        // } else {
        //   this.$store.state.support_articles.push(this.editedItem)
        // }
        // this.close()
      },
      // editItem (item) {
        //   // console.log(item)
        //   this.editedIndex = this.$store.state.support_articles.indexOf(item)
        //   // console.log(this.editedIndex)
        //   this.editedItem = Object.assign({}, item)
        //   // console.log(this.editedItem)
        //   this.dialog = true
      // }
    },
    components: { TextEditor }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/support/EditArticle.vue